import o from "axios";
const s = async (e, t, a, n) => {
  try {
    const r = {
      orderFormId: e,
      skuId: a,
      substitutionId: n
    };
    if (t) {
      const { data: d } = await o.post(
        "/_v/commerce/orderform/changeOrder",
        r
      );
      return d;
    }
    const { data: c } = await o.post("/api/proxy", {
      targetUrl: "/_v/commerce/orderform/changeOrder",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: r
    });
    return c;
  } catch (r) {
    console.error("Error in Change Order Modal", r);
  }
};
export {
  s as postChangeOrder
};
